<span (click)="switchOpen.emit()" class="burger">
  <ui-icon [faName]="isOpen ? 'xmark' : 'bars'" faStyle="light"></ui-icon>
</span>

<span
  (click)="collapse.emit()"
  [hidden]="!isOpen || !isExpanded"
  class="collapse"
>
  <ui-icon faName="arrow-left" faStyle="light"></ui-icon>
  <span>Zurück</span>
</span>
